import React, { Component } from 'react';
import { authHeaderJson } from '../auth-header';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import EditIcon from '@material-ui/icons/Subject';
import IconFirstPage from '@material-ui/icons/FirstPage';
import IconPrev from '@material-ui/icons/NavigateBefore';
import IconNext from '@material-ui/icons/NavigateNext';
import IconError from '@material-ui/icons/ErrorOutline';
import IconOK from '@material-ui/icons/CheckCircleOutline';

import IconLastPage from '@material-ui/icons/LastPage';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import SearchIcon from '@material-ui/icons/Search';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { IconButton, Dialog, Button, InputBase, CircularProgress, AppBar, Typography, Toolbar } from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    numberField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 100,
    },
    radio: {
        height: 30,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        marginRight: 5,
    },
    editor: {
        height: 320,
    },
    editor2: {
        height: 300
    },
    fab: {
        marginTop: theme.spacing.unit * 2,
        position: 'absolute',
        right: theme.spacing.unit * 2,
    },
    grow: {
        flexGrow: 1,
    },


    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    },
    error: {
        color: theme.palette.error.main,
    }
});


class NotificationsEmails extends Component {
    static displayName = NotificationsEmails.name;

    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            loading: true,
            dialogOpen: false,
            notDataId: 0,
            search: '',
            currentPage: 1,
            pageCount: 0,
            data: {}
        };
        this.handleClose = this.handleClose.bind(this);
    };


    componentDidMount() {
        this.loadNots();
    }

    getDateTime(datstr) {
        if (datstr === null) return '';
        var dat = new Date(datstr);
        var yyyy = dat.getFullYear();
        var mm = dat.getMonth() < 9 ? "0" + (dat.getMonth() + 1) : (dat.getMonth() + 1); // getMonth() is zero-based
        var dd = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
        var hh = dat.getHours() < 10 ? "0" + dat.getHours() : dat.getHours();
        var min = dat.getMinutes() < 10 ? "0" + dat.getMinutes() : dat.getMinutes();
        var ss = dat.getSeconds() < 10 ? "0" + dat.getSeconds() : dat.getSeconds();
        return "" + dd + "." + mm + "." + yyyy + " " + hh + ":" + min + ":" + ss;
    };
    firstPage() {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: 1 }, () => this.loadNots());
        }
    }
    prevPage() {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 }, () => this.loadNots());
        }
    }
    nextPage() {
        var curr = this.state.currentPage;
        if (curr < this.state.pageCount) {
            this.setState({ currentPage: curr + 1 }, () => this.loadNots());
        }
    }
    lastPage() {
        var curr = this.state.currentPage;
        if (curr < this.state.pageCount) {
            this.setState({ currentPage: this.state.pageCount }, () => this.loadNots());
        }
    }
    loadNots() {
        this.setState({ loading: true });
        //        console.log(this.state.currentPage);
        fetch('api/SentMails', { headers: authHeaderJson(), body: JSON.stringify({ page: this.state.currentPage, search: this.state.search, rows: 30 }), method: 'post' })
            .then(response => response.json())
            .then(data => {
                //                console.log(data);
                this.setState({
                    listData: data.results,
                    pageCount: data.pageCount,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({ loading: false });
            });
    }


    show(event, id) {
        fetch('api/SentMails/' + id, { headers: authHeaderJson() })
            .then(res => res.json())
            .then(datax => {
                //                console.log(data);
                this.setState({
                    data:datax,
                    dialogOpen: true
                });
            })
            .catch(err => { console.error(err); })
    }


    handleClose() {
        this.setState({ dialogOpen: false });
    }

    render() {
        const { classes } = this.props;
        const { fullScreen } = this.props;

        let contents = (
            this.state.loading ? <CircularProgress /> :
            <Table padding="none">
                <TableHead>
                    <TableRow>
                        <TableCell padding="dense">Deň</TableCell>
                        <TableCell>Pre</TableCell>
                        <TableCell>Predmet</TableCell>
                        <TableCell>Stav</TableCell>
                        <TableCell></TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.listData.map(not =>
                        <TableRow key={not.id} onDoubleClick={event => this.show(event, not.id)} hover>
                            <TableCell padding='dense' >{this.getDateTime(not.timestamp)}</TableCell>
                            <TableCell>{not.mailTo}</TableCell>
                            <TableCell>{not.subject}</TableCell>
                            <TableCell>{not.sendStatus === 0 ? <IconOK /> : <IconError className={classes.error} />}</TableCell>
                            <TableCell>
                                <IconButton onClick={event => this.show(event, not.id)}><EditIcon /></IconButton >
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        )

        return (
            <div className={classes.root} >
                <AppBar position="static">
                    <Toolbar>
                        <Typography className={classes.grow} variant="h6" color="inherit">Odoslané maily</Typography>

                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <InputBase
                                placeholder="Hľadať…"
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={e => this.setState({ search: e.target.value }, () => this.loadNots())}
                            />
                        </div>

                        <IconButton color="inherit" disabled={this.state.currentPage <= 1} onClick={this.firstPage.bind(this)}>
                            <IconFirstPage fontSize="small" />
                        </IconButton>
                        <IconButton color="inherit" disabled={this.state.currentPage <= 1} onClick={this.prevPage.bind(this)}>
                            <IconPrev fontSize="small" />
                        </IconButton>
                        <Typography variant="body1" color="inherit">{this.state.currentPage}/{this.state.pageCount}</Typography>

                        <IconButton color="inherit" disabled={this.state.currentPage === this.state.pageCount} onClick={this.nextPage.bind(this)}>
                            <IconNext fontSize="small" />
                        </IconButton>
                        <IconButton color="inherit" disabled={this.state.currentPage === this.state.pageCount} onClick={this.lastPage.bind(this)}>
                            <IconLastPage fontSize="small" />
                        </IconButton>


                    </Toolbar>
                </AppBar>
                <Paper>
                    {contents}
                </Paper>

                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                    scroll="paper"
                    maxWidth="lg"
                >
                    <DialogTitle id="responsive-dialog-title">{"Záznam " + this.getDateTime(this.state.data.timestamp)}</DialogTitle>
                    <DialogContent>
                        <Typography variant="subtitle2" component="div">Pre: {this.state.data.mailTo}</Typography>
                        <Typography variant="subtitle2" component="div">Stav: {this.state.data.sendStatus === 0 ? "Odoslané" : this.state.data.sendProcRes}</Typography>
                        <Typography variant="subtitle2" component="div">Predmet: {this.state.data.subject}</Typography>
                        <Typography variant="caption" component="div" dangerouslySetInnerHTML={{ __html: this.state.data.mailBody }} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={e => this.handleClose()} color="secondary" variant="outlined"><CancelIcon />Zrušiť</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
NotificationsEmails.propTypes = {
    classes: PropTypes.object.isRequired,
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(withStyles(styles)(NotificationsEmails));


// WEBPACK FOOTER //
// ./src/components/pssr/NotEmails.jsx